/* Local MK61 preparation: one repair and one linked standard inspection; no writes at module load. */
(function () {
  'use strict';
  if (window.RFMk61Cart) return;
  var version = 'mk61-v1', feeId = 55744436404606;
  function properties(item) { return item.properties || {}; }
  function owns(item, group) {
    var p = properties(item);
    return p._rf_contract === version && (p._rf_group === group || p._rf_parent === group);
  }
  function inspect(cart, expected) {
    if (!cart || !Array.isArray(cart.items)) return { applicable: true, valid: false, reason: 'unreadable' };
    var items = cart.items, marked = items.filter(function (it) { return properties(it)._rf_contract === version; });
    if (!marked.length) return { applicable: !!expected, valid: !expected, reason: expected ? 'missing' : null };
    var mains = marked.filter(function (it) { return !properties(it)._rf_addon; });
    if (mains.length !== 1 || mains[0].quantity !== 1) return { applicable: true, valid: false, reason: 'repair-count' };
    var main = mains[0], group = properties(main)._rf_group;
    if (!group || (expected && (group !== expected.group || String(main.variant_id) !== String(expected.variantId)))) return { applicable: true, valid: false, reason: 'repair-mismatch' };
    if (items.some(function (it) { return !owns(it, group); })) return { applicable: true, valid: false, reason: 'mixed-cart' };
    var fees = marked.filter(function (it) { return properties(it)._rf_addon === 'pruefpauschale'; });
    if (fees.length !== 1 || fees[0].quantity !== 1 || Number(fees[0].variant_id) !== feeId || properties(fees[0])._rf_parent !== group) return { applicable: true, valid: false, reason: 'inspection-count' };
    if (cart.currency === 'EUR' && Number(fees[0].original_price) !== 6000) return { applicable: true, valid: false, reason: 'inspection-price' };
    if (expected && Number(main.original_price) !== expected.priceCents) return { applicable: true, valid: false, reason: 'repair-price' };
    var seen = {};
    var addonIds = { pruefpauschale: feeId, ups: 55492340842878, rueckversand: 55874775843198 };
    for (var i = 0; i < marked.length; i++) {
      var role = properties(marked[i])._rf_addon;
      if (!role) continue;
      if (['pruefpauschale', 'ups', 'rueckversand'].indexOf(role) < 0 || marked[i].quantity !== 1 || Number(marked[i].variant_id) !== addonIds[role] || seen[role]) return { applicable: true, valid: false, reason: 'addon-count' };
      seen[role] = true;
    }
    var declared = properties(main);
    var requireUps = expected ? expected.requireUps : declared['Versand und Abholung'] === 'Teil Abholen lassen';
    var requireReturn = expected ? expected.requireReturn : declared['Wahl der Rückversandmethode'] === 'Normalversand';
    if (!!seen.ups !== requireUps || !!seen.rueckversand !== requireReturn) return { applicable: true, valid: false, reason: 'shipping-choice' };
    return { applicable: true, valid: true, group: group };
  }
  function read(fetcher, root) {
    return fetcher(root + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) {
      if (!r.ok) throw new Error('Warenkorb konnte nicht geprüft werden. Bitte versuchen Sie es erneut.');
      return r.json();
    }).then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) throw new Error('Warenkorb konnte nicht geprüft werden. Bitte versuchen Sie es erneut.');
      return cart;
    });
  }
  function rollback(fetcher, root, group) {
    return read(fetcher, root).then(function (cart) {
      var updates = {};
      cart.items.filter(function (item) { return owns(item, group); }).forEach(function (item) { updates[item.key] = 0; });
      if (!Object.keys(updates).length) return true;
      return fetcher(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ updates: updates }) }).then(function (r) {
        if (!r.ok) return false;
        return read(fetcher, root).then(function (current) { return !current.items.some(function (item) { return owns(item, group); }); });
      });
    }).catch(function () { return false; });
  }
  function createGroup() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return 'rfmk61_' + window.crypto.randomUUID();
    return 'rfmk61_' + Date.now() + '_' + Math.random().toString(36).slice(2);
  }
  window.RFMk61Cart = { version: version, feeId: feeId, inspect: inspect, read: read, rollback: rollback, createGroup: createGroup };
})();
